<template>
  <div class="w-full">
    <div class="flex md:justify-between justify-center w-full relative">
      <div class="text-sm md:text-xs font-bold tracking-widest py-2">
        <slot name="header"></slot>
      </div>
      <button class="pr-2 flex hover:text-b2c-red-300 w-6 absolute right-0"
      @click="openEditModal()" aria-label="edit" v-if="false">
        <svg
          width="100%"
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="pen"
          class="svg-inline--fa fa-pen fa-w-16"
          role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path fill="currentColor" d="M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"></path>
        </svg>
      </button>
    </div>
    <div class="text-gray-700 flex flex-col text-sm md:text-xs tracking-widest py-2"
      :class="fontHairline()"
      v-if="address">
      <span>
        {{ address.company }}
      </span>
      <span>
        {{ address.address1 }}
      </span>
      <span>
        {{ address.postcode }}
      </span>
      <span>
        {{ address.city }}
      </span>
      <span>
        {{ address.phone }}
      </span>
    </div>
  </div>
</template>

<script>
import AddressForm from '@/components/profile/AddressForm.vue';
import ShippingAddressesList from '@/components/profile/ShippingAddressesList.vue';
import { mapGetters } from 'vuex';

export default {
  props: ['address', 'editable', 'isShipping', 'order'],

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      customer: 'auth/customer',
      billingAddressSaved: 'auth/billingAddress',
      shippingAddressesSaved: 'auth/shippingAddresses',
    }),
  },

  methods: {
    openEditModal() {
      if (this.isShipping) {
        this.$modal.show(ShippingAddressesList, {
          class: 'p-6', radioButtons: true, billingInList: true, order: this.order,
        }, { height: 'auto', adaptive: true });
        return;
      }
      const addressToEdit = this.address;
      const street = addressToEdit.address1.split(',')[0];
      addressToEdit.street = street;
      const number = addressToEdit.address1.split(',')[1];
      addressToEdit.number = number;
      this.$modal.show(AddressForm, {
        givenAddress: addressToEdit, class: 'p-6', editing: true, isShipping: this.isShipping, order: this.order,
      }, { height: 'auto', adaptive: true });
    },

    fontHairline() {
      if (window.navigator.userAgent.includes('Macintosh')) {
        return 'md:font-extralight';
      }
      return '';
    },
  },
};
</script>
